
import React from 'react';
import SidebarFrame from "./SidebarFrame";
import MeasureNumberInput from "../commons/MeasureNumberInput.js";


export default class ProductDragSettings extends SidebarFrame {

    renderTitle() {
        return this.props.title;
    }

    draggable(element, product) {
        APP.interactionHandler.draggable(element)
            .setDragObject3D((handle) => APP.model.createDragObject(product));

    }

    bild(product) {
        const bild = product.Bild || "default.png";
        return SETTINGS.wkfgContentBaseUrl + bild;
    }

    get tuer() {
        return this.props.model.vsData;
    }
    handleFocus(e) {
        e.currentTarget.select();
    }

    changeHeight(e, object) {
        object.inputVisible = false;
        object.changeHeight(e);

    }
    click(e, object) {
        object.inputVisible = false;
        object.changeHeight(e);
    }
    remove(e, object) {
        object.inputVisible = false;
    }

    renderBody() {

        return (
            <div className="appear">
                {APP.arrangement.getInterieurs().filter(t => t.type == 'Tuer').map((o,i) => {
                    const frontSizeY = o.frontBox.getSize().y;
                    return (
                        o.inputVisible && <div>
                            <MeasureNumberInput
                                label={I18N(`Türmaße`, o.object3d.name + ': ' + (i+1))}
                                value={frontSizeY}
                                onCommit={(e) => { this.changeHeight(e , o) }}
                                onFocus={this.handleFocus}
                            />
                            {/* <button className='button primary small-button' onClick={(e) => this.click(e, o)}>{I18N(`Ok`)}</button>
                            <button className='button small-button' onClick={(e) => this.remove(e, o)}>{I18N(`Abbrechen`)}</button> */}
                        </div>
                    )
                })}
                <fieldset>
                    {this.props.products.map((product, index) =>
                        <div key={index} className="productdrag image-text stop-select" ref={e => this.draggable(e, product)} onClick={this.onClick}>
                            <div className="image no-pointer" style={{ backgroundImage: 'url(' + this.bild(product) + ')' }}></div>
                            <div className="text">{product.Anzeigename}</div>
                            <div className="info" onClick={() => APP.uiHandler.showHelpPopup(product)}></div>
                        </div>
                    )}
                </fieldset>
            </div>
        )
    }
}